import { unarchiveWorkflows as unarchive } from 'api/WorkflowsAPI';
import { addPositiveToast, addNegativeToastWithErrorId } from 'modules/toastContainer';
import type { AppDispatch } from 'modules/app/components/App';

import { WorkflowIdData } from '../types';

const displayText = {
  failure: 'Could not unarchive',
  success: 'Successfully unarchived',
  workflow: 'journey',
  workflows: 'journeys',
};

export const unarchiveWorkflows = async (workflows: WorkflowIdData[], dispatch: AppDispatch) => {
  const workflowOrWorkflows = workflows.length > 1 ? displayText.workflows : displayText.workflow;
  try {
    const { success, fail } = await unarchive(workflows.map(({ id }) => id));

    if (success.length && fail.length) {
      const successfulWorkflowOrWorkflows = `${success.length} ${
        success.length > 1 ? displayText.workflows : displayText.workflow
      }`;
      const failedWorkflowOrWorkflows = `${fail.length} ${
        fail.length > 1 ? displayText.workflows : displayText.workflow
      }`;

      dispatch(
        addNegativeToastWithErrorId(
          `${displayText.failure} ${failedWorkflowOrWorkflows}`,
          'unarchiveWorkflows',
        ),
      );
      dispatch(addPositiveToast(`${displayText.success} ${successfulWorkflowOrWorkflows}`));
    } else if (fail.length) {
      dispatch(
        addNegativeToastWithErrorId(
          `${displayText.failure} ${workflowOrWorkflows}`,
          'unarchiveWorkflows',
        ),
      );
    } else {
      dispatch(addPositiveToast(`${displayText.success} ${workflowOrWorkflows}`));
    }
  } catch (e) {
    dispatch(
      addNegativeToastWithErrorId(
        `${displayText.failure} ${workflowOrWorkflows}`,
        'unarchiveWorkflows',
      ),
    );
  }
};
